import { Heading, Modal, ModalCancelButton, ModalCloseButton, ModalWidth } from '@dreryk/react-components';

import { invoiceCreateAccountModalTranslationKeys } from '../../translations';

import { InvoiceCreateAccountForm } from './form/InvoiceCreateAccountForm';
import { InvoiceCreateAccountFormLoader } from './form/InvoiceCreateAccountForm.loader';
import { InvoiceCreateAccountModalConfirmButton } from './InvoiceCreateAccountModalConfirmButton';

type InvoiceCreateAccountModalProps = {
   readonly onClose: VoidFunction;
};

export const InvoiceCreateAccountModal = (props: InvoiceCreateAccountModalProps): JSX.Element => {
   return (
      <Modal
         testId={'invoiceCreateAccountModal'}
         title={
            <Heading
               content={invoiceCreateAccountModalTranslationKeys.title}
               testId={'invoiceCreateAccountModalTitle'}
               type='h1'
               bold
               margin={'0px'}
            />
         }
         width={ModalWidth.WIDE}
      >
         <InvoiceCreateAccountFormLoader>
            {({ currentHealthcareProviderInvoiceData }) => (
               <InvoiceCreateAccountForm currentHealthcareProviderInvoiceData={currentHealthcareProviderInvoiceData}>
                  {({ handleSubmit, formState }) => (
                     <>
                        <InvoiceCreateAccountModalConfirmButton handleSubmit={handleSubmit} onClose={props.onClose} />
                        <ModalCancelButton
                           onClick={props.onClose}
                           shouldConfirmExit={{
                              enabled: formState.isDirty,
                              content: invoiceCreateAccountModalTranslationKeys.confirmLeavingForm,
                           }}
                        />
                        <ModalCloseButton
                           onClick={props.onClose}
                           shouldConfirmExit={{
                              enabled: formState.isDirty,
                              content: invoiceCreateAccountModalTranslationKeys.confirmLeavingForm,
                           }}
                        />
                     </>
                  )}
               </InvoiceCreateAccountForm>
            )}
         </InvoiceCreateAccountFormLoader>
      </Modal>
   );
};
